// extracted by mini-css-extract-plugin
module.exports = {"container":"OfsAccessSelect_container__2s4VD"};